import { request } from '../request';

export const securityApi = {
  getFileGuard: () => request('/config/security/file-guard'),

  updateFileGuard: (body) =>
    request('/config/security/file-guard', {
      method: 'PUT',
      body: JSON.stringify(body)
    }),

  getToolGuard: () => request('/config/security/tool-guard'),

  updateToolGuard: (body) =>
    request('/config/security/tool-guard', {
      method: 'PUT',
      body: JSON.stringify(body)
    }),

  getBuiltinRules: () => request('/config/security/tool-guard/builtin-rules'),

  getSkillScanner: () => request('/config/security/skill-scanner'),

  updateSkillScanner: (body) =>
    request('/config/security/skill-scanner', {
      method: 'PUT',
      body: JSON.stringify(body)
    }),

  getBlockedHistory: () => request('/config/security/skill-scanner/blocked-history'),

  clearBlockedHistory: () =>
    request('/config/security/skill-scanner/blocked-history', {
      method: 'DELETE'
    }),

  removeBlockedEntry: (index) =>
    request(`/config/security/skill-scanner/blocked-history/${index}`, {
      method: 'DELETE'
    }),

  addToWhitelist: (skillName, contentHash = '') =>
    request('/config/security/skill-scanner/whitelist', {
      method: 'POST',
      body: JSON.stringify({ skill_name: skillName, content_hash: contentHash })
    }),

  removeFromWhitelist: (skillName) =>
    request(`/config/security/skill-scanner/whitelist/${encodeURIComponent(skillName)}`, {
      method: 'DELETE'
    })
};
